package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.AccountRepository
import com.clany.backoffice.model.AccountResponse
import com.clany.backoffice.model.UpdateAccountRequest
import dev.zacsweers.metro.Inject

@Inject
class UpdateAccountUseCase(
    private val repository: AccountRepository
) {
    suspend operator fun invoke(request: UpdateAccountRequest): Result<AccountResponse> {
        return repository.updateAccount(request)
    }
}
